import { ReportOutputType } from '../../graphql/schema/p4types';

export const BasicOutputSelection = [
  {
    value: ReportOutputType.Email,
    label: 'E-Mail',
  },
  {
    value: ReportOutputType.LocalPrinter,
    label: 'Local Printer',
  },
  {
    value: ReportOutputType.SystemPrinter,
    label: 'System Printer',
  },
  {
    value: ReportOutputType.Xlsx,
    label: 'XLSX Spreadsheet',
  },
];
